import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import { AuthProvider } from './context/AuthContext';
import HomePage from './pages/HomePage';
// BlogPage / BlogPostPage imports removed while the blog is pulled (2026-07-29, job-search focus); re-import to restore.
// EatingPage / RecipePage imports removed while "What Am I Eating" is pulled; re-import to restore.
import LoginPage from './pages/LoginPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import Dashboard from './pages/admin/Dashboard';
function ExternalRedirect({ to }) {
  React.useEffect(() => { window.location.replace(to); }, [to]);
  return null;
}

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* Blog temporarily pulled (2026-07-29) while the site is resume-focused; restore BlogPage/BlogPostPage routes to bring it back */}
          <Route path="/blog" element={<Navigate to="/" replace />} />
          <Route path="/blog/:slug" element={<Navigate to="/" replace />} />
          {/* "What Am I Eating?" temporarily pulled (2026-07-17); restore EatingPage/RecipePage routes to bring it back */}
          <Route path="/eating" element={<Navigate to="/" replace />} />
          <Route path="/eating/:slug" element={<Navigate to="/" replace />} />
          <Route path="/dice" element={<ExternalRedirect to="/dice.html" />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin" element={<Dashboard />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;
